import React, { useState } from 'react';
import BottomNavbar from '../userNavbar/BottomNavbar';
import TopNavBar from '../userNavbar/TopNavBar';

const UserNavbar = () => {

    const [menuOpen, setMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null)

    return (
        <div className="sticky top-0 bg-white w-full z-50">
            <TopNavBar menuOpen={menuOpen} activeDropdown={activeDropdown} setMenuOpen={setMenuOpen} setActiveDropdown={setActiveDropdown} />
            <BottomNavbar menuOpen={menuOpen} activeDropdown={activeDropdown} setMenuOpen={setMenuOpen} setActiveDropdown={setActiveDropdown} />
        </div>
    );
};

export default UserNavbar;